// extracted by mini-css-extract-plugin
export default {"startButton":"LandingPage_startButton__GzPGC"};